export default __webpack_public_path__ + "static/media/scsprite.3daacd73.png";